module.exports = __webpack_public_path__ + "media/images/shared/bank-logo-d47217b51f2110f6989203c8b24dd71e.svg";